export default __webpack_public_path__ + "static/media/social-interaction-1-animate.7f865e97.svg";